/* eslint-disable import/prefer-default-export */
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import API from '../../../network';
import { SendBulkMailRequestBody } from './types';

const useMailMergeTemplate = () => {
  const [loading, setLoading] = useState(false);

  const getTemplate = async (jobOrderId: number) => {
    setLoading(true);
    const template = await API.getInstance().getMailMergeTemplate(jobOrderId);
    setLoading(false);
    return template.data;
  };

  return {
    templateFetching: loading,
    getTemplate,
  };
};

const useSendBulkMail = () => {
  const {
    mutateAsync, error, status, isPending,
  } = useMutation({
    mutationFn: async (data: SendBulkMailRequestBody) => API.getInstance().sendBulkMail(data),
  });

  const sendMail = async (
    data: SendBulkMailRequestBody,
  ) => new Promise((resolve) => {
    const promise = mutateAsync(data).then(async () => {
      resolve(true);
    });
    toast.promise(promise, {
      loading: 'Please wait...',
      success: 'Mail sent successfully',
      error: (err: any) => `${err?.response?.data?.message || error || 'something went wrong!'}`,
    }, {
      position: 'bottom-center',
    });
  });

  return {
    sendMail,
    mailSending: isPending,
    error,
    status,
  };
};

export {
  useMailMergeTemplate,
  useSendBulkMail,
};
